/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
/* eslint-disable import/no-unresolved */
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {
  getMessaging,
  getToken,
  onMessage,
} from 'firebase/messaging'
import { initializeApp } from 'firebase/app'
import moment from 'moment'
import { FULL_DATE_TIME } from '@/libs/filterDate'
import secureLocalStorage from '@/libs/secureLocalstorage'
import HistoryShipping from './HistoryShipping.vue'

window.onload = () => {
  const theElement = document.getElementById('chatFocusing')
  const scrollToBottom = node => {
    // eslint-disable-next-line no-param-reassign
    node.scrollTop = node.scrollHeight
  }
  scrollToBottom(theElement)
}

const firebaseConfig = {
  apiKey: 'AIzaSyCPYJYeP-9_G3S5MOV_-8QPDSmxF8dj84g',
  authDomain: 'komship-ticketing.firebaseapp.com',
  projectId: 'komship-ticketing',
  storageBucket: 'komship-ticketing.appspot.com',
  messagingSenderId: '669211426801',
  appId: '1:669211426801:web:55bca3d2dac7238b298e50',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Cloud Messaging and get a reference to the service
const messaging = getMessaging()

export default {
  components: { vSelect, HistoryShipping },
  data() {
    return {
      ticketId: this.$route.params.ticket_id,
      loadingDataDetail: true,

      ticketStatus: 0,
      orderStatus: '',
      ticketNo: '',
      noResi: '',
      ekspedisi: '',
      seller: '',
      ticketType: '',
      customerName: '',
      description: '',
      files: [],

      // Chat
      loadingDataChat: false,
      messages: [],
      chatItem: '',
      fcmToken: '',
      fileChat: null,
      chatFileMode: false,
      imageFileChat: null,
      imageInitialFile: null,
      imageFile: null,
      itemsImageInitialFile: [],

      // cancel ticket
      loadingCancelTicket: false,
      moment,

      changeStatus: [
        {
          label: 'Menunggu Tindak Lanjut',
          value: 0,
        },
        {
          label: 'Sedang diproses',
          value: 2,
        },
      ],
      ticketStatusItem: null,

      userId: secureLocalStorage.get('userData'),

      // Validation Store Chat
      messageErrorStatus: false,
      activeSend: false,
      statusPriority: 0,

      datas: {},
      loading: true,
      dataDetailTiket: {},
      GrandTotal: '',

      isShowChatboxPlaceholder: true,
      FULL_DATE_TIME,
    }
  },
  created() {
    this.receiveMessage()
  },
  async mounted() {
    this.fetchDataFirebase()
    await this.fetchDetailTicket()
    const theElement = document.getElementById('chatFocusing')
    if (theElement !== null) {
      const scrollToBottom = node => {
      // eslint-disable-next-line no-param-reassign
        node.scrollTop = node.scrollHeight
      }
      scrollToBottom(theElement)
    }
    this.readChat()
  },
  methods: {
    async fetchDetailTicket() {
      this.messageErrorStatus = false
      await this.$http_komship.get(`/v1/ticket-mitra/detail/${this.ticketId}`)
        .then(response => {
          const { data } = response.data
          this.ticketStatus = data.ticket_status
          this.orderStatus = data.order_status
          this.ticketNo = data.ticket_no
          this.ticketType = data.ticket_type
          this.customerName = data.customer_name
          this.description = data.description
          this.seller = data.partner_name
          this.ekspedisi = data.shipping
          this.noResi = data.no_resi
          this.files = data.file
          this.messages = data.history_ticket
          this.loadingDataDetail = false
          this.statusPriority = data.status_priority
          this.dataDetailTiket = data
          this.GrandTotal = data.grand_total
          this.loading = false
          setTimeout(() => {
            const theElement = document.getElementById('chatFocusing')
            const scrollToBottom = node => {
              // eslint-disable-next-line no-param-reassign
              node.scrollTop = node.scrollHeight
            }
            scrollToBottom(theElement)
          }, 500)
        })
        .catch(err => {
          this.loadingDataDetail = false
        })
    },
    storeChat() {
      this.loadingDataChat = true
      if (this.ticketStatusItem !== null) {
        const formData = new FormData()
        if (this.chatItem) formData.append('message', this.chatItem)
        formData.append('ticket_id', Number(this.ticketId))
        formData.append('ticket_status', this.ticketStatusItem)
        if (this.itemsImageInitialFile.length > 1) {
        // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.itemsImageInitialFile.length; i++) {
            formData.append('file[]', this.itemsImageInitialFile[i])
          }
        } else {
          formData.append('file[]', this.itemsImageInitialFile[0])
        }
        this.$http_komship.post('/v2/ticket-mitra/store-chat', formData)
          .then(() => {
            // fetch('https://fcm.googleapis.com/fcm/send', {
            //   method: 'POST',
            //   headers: {
            //     'Content-Type': 'application/json',
            //     Authorization: 'key=AAAAm9Ab__E:APA91bF7K9M9Adw_2DbHcySgjESrZjV_i6QCURNX4TaHwo8ah3VX1j3e_DJb3CV7cdEtgIXkfTAHrNqvuAwMElQMnflI6z0_E1BcAX9OPfIVCZ4ewiOq1N2dhHWYcsBQ7Nu4nFFQF8-2',
            //   },
            //   body: JSON.stringify({
            //     to: this.fcmToken,
            //   }),
            // })
            //   .then(() => {
            this.chatItem = ''
            this.itemsImageInitialFile = []
            this.loadingDataChat = false
            this.ticketStatusItem = null
            this.chatFileMode = false
            this.fetchDetailTicket()
            // })
            // .catch(err => {
            //   this.$toast({
            //     component: ToastificationContent,
            //     props: {
            //       title: 'Failure',
            //       icon: 'AlertCircleIcon',
            //       text: err,
            //       variant: 'danger',
            //     },
            //   }, 2000)
            //   this.loadingDataChat = false
            // })
          }).catch(err => {
            this.loadingDataChat = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Failure',
                icon: 'AlertCircleIcon',
                text: err,
                variant: 'danger',
              },
            }, 2000)
          })
      } else {
        this.messageErrorStatus = true
        this.loadingDataChat = false
      }
    },
    statusTicketVariant(data) {
      let resultVariant = ''
      if (data === 1) {
        resultVariant = 'light-primary'
      } else if (data === 2) {
        resultVariant = 'light-warning'
      } else if (data === 3) {
        resultVariant = 'light-success'
      } else if (data === 4) {
        resultVariant = 'light-secondary'
      }
      return resultVariant
    },
    orderStatusVariant(data) {
      let result = ''
      if (data === 'Diajukan') {
        result = 'light-primary'
      } else if (data === 'Dipacking') {
        result = 'light-info'
      } else if (data === 'Dikirim') {
        result = 'light-warning'
      } else if (data === 'Diterima') {
        result = 'light-success'
      } else if (data === 'Retur') {
        result = 'light-danger'
      } else if (data === 'Batal') {
        result = 'light-dark'
      }
      return result
    },
    convertTicketStatus(data) {
      let result = ''
      if (data === 0) {
        result = 'Menunggu Tindak Lanjut'
      } else if (data === 1) {
        result = 'Perlu Diproses'
      } else if (data === 2) {
        result = 'Sedang Diproses'
      } else if (data === 3) {
        result = 'Selesai'
      } else if (data === 4) {
        result = 'Batal'
      }
      return result
    },
    fetchDataFirebase() {
      Notification.requestPermission().then(permission => {
        if (!('permission' in Notification)) {
          Notification.permission = permission
        }
        // you got permission !
      }, rejection => {
        // handle rejection here.
      })
      getToken(messaging, { vapidKey: 'BLZr38POWZ6vwjTUx4v2vlPHK-3fiI-DMPY18tAbu1dpchDiAYMyR7l2PE3WbH5hOM55X2zBR_C-5BLrpUA1-ZM' }).then(currentToken => {
        if (currentToken) {
          Notification.requestPermission().then(permission => {
            if (permission === 'denied' || permission === 'default') {
              this.$refs['modal-alert-notification'].show()
            }
          })
          this.fcmToken = currentToken
          this.$http
            .post('/user/update-fcm-token', {
              user_id: this.userId.id,
              fcm_token: currentToken,
            })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'No registration token available. Request permission to generate one.',
              variant: 'danger',
            },
          }, 2000)
        }
      }).catch(err => {
        this.$refs['modal-alert-notification'].show()
      })
    },
    fileUrl: file => (file ? URL.createObjectURL(file) : null),
    receiveMessage() {
      try {
        onMessage(messaging, payload => {
          this.loadingDataChat = true
          this.fetchDetailTicket()
          this.fetchDataFirebase()
          setTimeout(() => {
            this.loadingDataChat = false
          }, 300)
        })
      } catch (err) {
        setTimeout(() => {
          this.loadingDataChat = false
        }, 300)
      }
    },
    handleCloseAlertCancel() {
      this.$refs['alert-cancel-ticket'].hide()
    },
    cancelTicket() {
      this.$refs['alert-cancel-ticket'].show()
    },
    submitCancelTicket() {
      this.loadingCancelTicket = true
      this.$http_komship.delete(`/v1/ticket-mitra/cancel/${this.ticketId}`)
        .then(() => {
          this.fetchDetailTicket()
          this.loadingCancelTicket = false
          this.$refs['alert-cancel-ticket'].hide()
        }).catch(err => {
          this.loadingCancelTicket = false
        })
    },
    copyTicket(data) {
      /* Copy the text inside the text field */
      navigator.clipboard.writeText(data)

      /* Alert the copied text */
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `Copied the text ${data}`,
          icon: 'AlertCircleIcon',
          variant: 'warning',
        },
      }, 1000)
    },
    onChangeFile(event) {
      event.target.files.forEach(this.myFile)
    },
    myFile(data) {
      this.itemsImageInitialFile.push(data)
    },
    putFileChat(event) {
      event.target.files.forEach(this.myFile)
      this.chatFileMode = true
    },
    addFileChat(event) {
      event.target.files.forEach(this.myFile)
    },
    removeFileChat(data) {
      const findIndexObj = this.itemsImageInitialFile.findIndex(items => items.name === data.name)
      this.itemsImageInitialFile.splice(findIndexObj, 1)
      if (this.itemsImageInitialFile.length === 0) {
        this.chatFileMode = false
      }
    },
    disableButtonCancel(data) {
      let result = false
      if (data === 3) {
        result = true
      } else if (data === 4) {
        result = true
      }
      return result
    },
    getValueFile(value) {
      return value.replaceAll('/', '/ ')
    },
    validateTicketStatus() {
      this.messageErrorStatus = false
    },
    readChat() {
      const formData = new FormData()
      formData.append('ticket_id', this.ticketId)
      formData.append('user_id', this.userId.id)
      this.$http_komship.post('/v1/ticket-mitra/chat/read-all', formData).then(() => {}).catch(err => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failure',
            icon: 'AlertCircleIcon',
            text: err,
            variant: 'danger',
          },
        }, 2000)
      })
    },
    changeActiveSend() {
      this.activeSend = true
    },
    handleCloseAlert() {
      this.$refs['modal-alert-notification'].hide()
    },
    formatDate(value) {
      return moment(value).format('DD MMMM YYYY - hh:mm')
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(value)
    },
    handleCutUrl(value) {
      return value.substring(value.lastIndexOf('/') + 1, value.length)
    },
    handleRegexImage(filename) {
      return /\.(png|svg|jpg|jpeg|gif|webp|jfif)$/i.test(filename)
    },
    handleRegexDoc(filename) {
      return /\.(xlsx|xls|doc|docx|pdf)$/i.test(filename)
    },
    handelRegexVideo(filename) {
      return /\.(mp4)$/i.test(filename)
    },
    handleExtension(value) {
      return value.split('.')
        .pop()
    },
    handlePasteChatbox(event) {
      event.preventDefault()
      const clipboardData = event.clipboardData || window.clipboardData

      if (!clipboardData) return

      const pastedText = clipboardData.getData('text/plain')
      const items = clipboardData.items

      if (pastedText) {
        document.execCommand('insertText', false, pastedText)
      }

      if (items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          const item = items[i]

          if (item.type.indexOf('image') !== -1) {
            const file = item.getAsFile()
            this.myFile(file)
            this.chatFileMode = true
          }
        }
      }
    },
    messageAdapter(chat) {
      let link = null
      const convertToBoolean = text => {
        const anchorRegex = /<a\s+(?:[^>]*?\s+)?href=['"](.*?)['"][^>]*?>\[Lihat Bukti\]<\/a>/
        return anchorRegex.test(text)
      }
      const isProof = convertToBoolean(chat)
      if (typeof (chat) !== 'object' && !isProof) {
        const urlify = text => {
          const urlRegex = /(https?:\/\/[^\s]+)/g
          return text.replace(urlRegex, url => `<a href="${url}" target="_blank" class="text-white">${url}</a>`)
        }
        link = urlify(chat)
      } else {
        link = chat
      }
      return link
    },
  },
}
